module.exports = "../images/ajax-loader.gif";